<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 60%; min-width: 45rem;">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Patient Own Check In</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal" @submit.prevent>
                            <div class="form-section-container" style="grid-template-columns: 1fr 1fr; width: 100%;">
                                <!-- LEFT PANEL: Patient Selection & Notes -->
                                <div class="left-form-section-panel" style="min-height: fit-content; padding-right: 15px; border-right: 1px solid #eee;">
                                    <div style="margin-bottom: 20px;">
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 8px;">
                                            Select {{ $resident({ capitalize: true }) }} <span style="color:red">*</span>
                                        </p>
                                        
                                        <div v-if="!patient" style="margin-bottom: 10px; text-align: left;">
                                            <p class="submit-button blue-button" @click="displayPatientSearchModal = true" style="display: inline-block; width: auto; padding: 10px 20px; cursor: pointer; margin: 0;">
                                                Search {{ $resident({ capitalize: true }) }}
                                            </p>
                                        </div>

                                        <!-- Patient card info -->
                                        <div v-else class="individual-patient-container" style="padding: 12px; background-color: #f5f9ff; border-radius: 6px; border: 1px solid #d0e3ff; margin-bottom: 10px;">
                                            <div class="patient-result-info" style="text-align: left;">
                                                <p style="margin: 0 0 6px 0; font-size: 0.95em;">
                                                    <b>Name:</b> {{ patientName }}
                                                </p>
                                                <p v-if="patient.regulatory_information && patient.regulatory_information.length" style="margin: 0 0 6px 0; font-size: 0.95em;">
                                                    <b>Medicare Number:</b> {{ patient.regulatory_information[0].data }}
                                                </p>
                                                <p style="margin: 0 0 6px 0; font-size: 0.95em;">
                                                    <b>DOB:</b> {{ patient.personal_information ? patient.personal_information.dob : 'N/A' }}
                                                </p>
                                                <p style="margin: 0 0 8px 0; font-size: 0.95em;">
                                                    <b>Location:</b> {{ patient.physical_location && patient.physical_location.location ? patient.physical_location.location.name : 'N/A' }}
                                                </p>
                                                <p @click="displayPatientSearchModal = true" style="margin: 8px 0 0 0; color: #0870DC; cursor: pointer; text-decoration: underline; font-size: 0.9em; display: inline-block;">
                                                    Change {{ $resident({ capitalize: true }) }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div style="margin-bottom: 15px;">
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Bag ID</p>
                                        <input v-model="bagId" type="text" placeholder="Optional Bag ID..." style="width: 100%; border-radius: 4px; padding: 8px; border: 1px solid #ccc; box-sizing: border-box;" />
                                    </div>

                                    <div>
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Notes</p>
                                        <textarea v-model="notes" rows="5" style="width: 100%; border-radius: 4px; padding: 10px; border: 1px solid #ccc; font-family: inherit;" placeholder="Enter notes for this checkin..."></textarea>
                                    </div>
                                </div>
                                
                                <!-- RIGHT PANEL: Drug Search & Added Items -->
                                <div class="right-form-section-panel" style="display: flex; flex-direction: column; padding-left: 15px;">
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 8px;">Select Medication <span style="color:red">*</span></p>
                                    
                                    <div class="right-form-section-drug-entry" style="display: flex; margin-bottom: 15px; gap: 8px;">
                                        <Dropdown
                                            v-model="stock"
                                            ref="med"
                                            @keyup="debounceSearchDrugs"
                                            :loading="loadingDrugs"
                                            :options="drugList"
                                            optionLabel="full_name"
                                            :editable="true"
                                            style="flex: 1;"
                                            emptyMessage="No medications match that search."
                                            placeholder="Search Medication..."
                                        />
                                        <input v-model="qty" min="0.01" step="any" type="number" placeholder="Qty" style="width: 80px; padding: 8px; border-radius: 4px; border: 1px solid #ccc;" />
                                        <p class="submit-button blue-button" style="padding: 8px 15px; margin: 0; display: flex; align-items: center; justify-content: center;" @click="addDrug">Add</p>
                                    </div>

                                    <div class="right-form-section-drug-container" style="overflow-y: auto; max-height: 280px; flex: 1;">
                                        <table style="border-collapse: collapse; width: 100%;" v-if="drugs.length > 0">
                                            <thead>
                                                <tr style="border-bottom: 2px solid #ddd; text-align: left; font-size: 0.9em;">
                                                    <th style="padding-bottom: 8px; font-weight: bold;">Drug</th>
                                                    <th style="padding-bottom: 8px; text-align: center; width: 80px; font-weight: bold;">Quantity</th>
                                                    <th style="padding-bottom: 8px; width: 40px;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in drugs" :key="index" style="border-bottom: 1px solid #eee; font-size: 0.9em;">
                                                    <td style="padding: 10px 0; max-width: 250px; text-align: left;">
                                                        {{ item.stock_name }}
                                                    </td>
                                                    <td style="text-align: center; padding: 5px 0;">
                                                        <input 
                                                            type="number" 
                                                            v-model.number="item.qty" 
                                                            min="0.01" 
                                                            step="any" 
                                                            style="width: 70px; text-align: center; padding: 4px; border: 1px solid #ccc; border-radius: 4px;" 
                                                        />
                                                    </td>
                                                    <td style="text-align: center; padding: 10px 0;">
                                                        <button type="button" @click="removeDrug(index)" class="red-close-button small-button" style="width: 24px; height: 24px; min-width: auto; padding: 0;">
                                                            <i class="pi pi-times" style="padding: 0; font-size: 0.8em;"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p v-else style="color: #666; font-style: italic; text-align: left; margin-top: 10px;">No medications added yet.</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em; text-align: center; margin-top: 10px; margin-bottom: 0;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 15px 20px;">
                    <slot name="footer">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px; cursor: pointer; padding: 8px 20px; border-radius: 4px;" @click="closeModal">Cancel</p>
                        <p class="regular-button green-button" style="cursor: pointer; padding: 8px 20px; border-radius: 4px;" @click="submitCheckin">Sign Off</p>
                    </slot>
                </div>
            </div>
        </div>
        
        <!-- Nested signature and patient search modals -->
        <PatientSearchModal @close="displayPatientSearchModal = false" v-if="displayPatientSearchModal" @patient="getPatient" />
        <SignatureModal v-if="displaySignatureModal" :payload="realSubmit" @isSuccessful="isSuccessful" @close="closeSignature" :saveContext="saveContext" endpoint="/receive-pom" />
    </div>
</template>

<script>
import SignatureModal from '@/components/modals/SignatureModal.vue';
import PatientSearchModal from '@/components/modals/PatientSearchModal.vue';
import Dropdown from 'primevue/dropdown';
import axios from 'axios';
import { pickerSearchTerm } from '@/services/pickers';
import { debounce, DEFAULT_DEBOUNCE_MS, DEFAULT_MIN_QUERY_LENGTH } from '@/services/debounce';
import { decorateDrugAliases } from '@/services/stockItemDisplay';
import { drugsRequireDoubleSig } from '@/services/doubleSignature';

export default {
    components: {
        SignatureModal,
        PatientSearchModal,
        Dropdown
    },
    data() {
        return {
            patient: null,
            displayPatientSearchModal: false,
            displaySignatureModal: false,
            notes: '',
            stock: '',
            qty: null,
            drugList: [],
            loadingDrugs: false,
            drugs: [],
            errorMessage: '',
            realSubmit: null,
            saveContext: null,
            bagId: ''
        };
    },
    computed: {
        patientName() {
            const p = this.patient;
            if (!p) return 'N/A';
            const info = p.latest_personal_information || p.personal_information;
            if (!info) return 'N/A';
            const first = info.firstname || info.first_name || '';
            const last = info.lastname || info.last_name || '';
            return `${first} ${last}`.trim() || 'N/A';
        },
        requiresDoubleSig() {
            const facility = this.$store.getters.getCurrentLocation?.facility;
            return drugsRequireDoubleSig(this.drugs.filter(d => d.qty > 0), facility);
        }
    },
    methods: {
        closeModal() {
            this.$emit('close', true);
        },
        getPatient(patient) {
            this.patient = patient;
            this.displayPatientSearchModal = false;
            this.errorMessage = '';
        },
        debounceSearchDrugs: debounce(function () {
            const searchTerm = pickerSearchTerm(this.stock);
            // Nothing is looked up until there are enough characters to be worth a request.
            // Clearing the list on the way back down stops a longer query's results sitting
            // there after the user has deleted back below the minimum.
            if (searchTerm.length < DEFAULT_MIN_QUERY_LENGTH) {
                this.drugList = [];
                return;
            }
            this.searchDrugs();
        }, DEFAULT_DEBOUNCE_MS),
        searchDrugs() {
            const searchTerm = pickerSearchTerm(this.stock);
            if (!searchTerm) return;

            this.loadingDrugs = true;
            // generics 0 searches active ingredients and brands together. Restricting this to
            // generics (1) added `whereNull('parent_drug_id')` on kraken's side, which excludes
            // every brand - so Endone and the like could never be found, even though patient
            // own medications arrive labelled with brand names.
            axios.post('/get-drug-aliases', { drug: searchTerm, generics: 0 }, this.$store.state.header).then(res => {
                this.drugList = decorateDrugAliases(res.data.drug_aliases || []);
                this.loadingDrugs = false;
                // An editable PrimeVue Dropdown never opens itself: typing only updates the
                // model, and a click landing on the text input is ignored by its container
                // handler. Without this the results load behind a closed overlay and the user
                // has to click the chevron to see them.
                this.$nextTick(() => {
                    if (this.$refs.med) {
                        this.$refs.med.show();
                    }
                });
            }).catch(err => {
                this.loadingDrugs = false;
                console.error(err);
            });
        },
        addDrug() {
            if (!this.stock || typeof this.stock === 'string') {
                this.errorMessage = "Please select a valid medication from the search list.";
                return;
            }
            if (!this.qty || this.qty <= 0) {
                this.errorMessage = "Please enter a quantity greater than 0.";
                return;
            }

            // Check if drug already added
            const exists = this.drugs.find(d => d.alias.alias_id === this.stock.alias_id);
            if (exists) {
                exists.qty = Number((exists.qty + Number(this.qty)).toFixed(2));
            } else {
                this.drugs.unshift({
                    alias: this.stock,
                    stock_name: this.stock.name,
                    qty: Number(this.qty)
                });
            }

            this.stock = '';
            this.qty = null;
            this.errorMessage = '';
        },
        removeDrug(index) {
            this.drugs.splice(index, 1);
        },
        submitCheckin() {
            if (!this.patient) {
                this.errorMessage = `Please select a ${this.$resident({ lowercase: true })}.`;
                return;
            }
            if (this.drugs.length === 0) {
                this.errorMessage = "At least one medication is required.";
                return;
            }

            for (const d of this.drugs) {
                if (d.qty === null || d.qty === undefined || isNaN(d.qty) || d.qty <= 0) {
                    this.errorMessage = `Please enter a valid quantity greater than 0 for ${d.stock_name}.`;
                    return;
                }
            }

            const formattedDrugs = this.drugs.map(d => {
                return {
                    drug: d.alias.alias_id,
                    qty: Number(d.qty),
                    // tags may be strings or { name } objects depending on the source endpoint
                    tags: (d.alias?.tags || []).map(t => t?.name ?? t)
                };
            });

            this.realSubmit = {
                patient_id: this.patient.uuid,
                notes: this.notes,
                bag_id: this.bagId ? this.bagId.trim() : null,
                drugs: formattedDrugs
            };

            this.saveContext = {
                type: 'Patient Own Checkin',
                patient: `${this.patient.personal_information.first_name} ${this.patient.personal_information.last_name}`,
                location: this.$store.state.currentLocation.name,
                drugs: this.drugs.map(d => ({ drug: d.stock_name, qty: d.qty })),
                doubleSig: this.requiresDoubleSig,
                bag_id: this.bagId ? this.bagId.trim() : null
            };

            this.errorMessage = '';
            this.displaySignatureModal = true;
        },
        closeSignature(value) {
            if (value) {
                this.displaySignatureModal = false;
            }
        },
        isSuccessful(value) {
            if (value) {
                this.$emit('close', true, 'success');
            }
        }
    }
};
</script>

<style scoped>
/* Scoped styles helper to override native dropdown padding or number spinner if needed */
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
input[type=number] {
  -moz-appearance: textfield;
}
.right-form-section-drug-entry :deep(.p-dropdown) {
    display: flex;
    align-items: center;
}
</style>
